<template>
  <div class="Scroll w-full h-full">
    <div class="flex flex-col sm:flex-row sm:flex-wrap mb-3">
      <div
        v-for="(report, index) in reports.data"
        :key="index"
        class="flex flex-col p-3 sm:w-2/4 lg:w-1/3 bg-gray-400 rounded border border-gray-500">
        <span class="text-sm text-white">{{ report.nomor + ' - ' + report.status }}</span>
        <span class="text-xs text-gray-100">{{ report.analis }} <small>({{ report.verifikator }})</small></span>
        <div class="flex gap-1 justify-end items-center">
          <button
            @click="downloadReport(report)"
            class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-slate-500"
            type="button"
            title="Download Laporan">
            <i class="material-icons text-sm">download</i>
          </button>
        </div>
      </div>
    </div>
    <Pagination
      class="justify-end items-end"
      :offset="reports.offset"
      :limit="reports.limit"
      :total="reports.total"
      :handler="changePage" />
    <PopupMessage :message="message" :confirm="{ success: confirmSuccess }" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from './Pagination.vue'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'TableReport',
  computed: {
    ...mapGetters([
      'message',
      'reports'
    ])
  },
  components: {
    Pagination,
    PopupMessage
  },
  methods: {
    ...mapActions(['toLoadReports']),
    changePage: async function (page) {
      await this.toLoadReports({
        offset: page.offset,
        limit: page.limit
      })
    },
    confirmSuccess: async function () {
      await this.toLoadReports()
    },
    downloadReport: function (report) {
      window.open(
        // eslint-disable-next-line
        `${window.config.BASEURL}/document/reports/${report.nomor.replaceAll(/[\/\.]/g, '')}.pdf`,
        '_blank'
      )
    }
  },
  mounted: async function () {
    await this.toLoadReports()
  }
}
</script>
